module.exports = __webpack_public_path__ + "img/mMiddlebg.6a3d40a2.png";